const validateEmail = email => email.indexOf( '@' ) !== -1 && email?.split( '@' )?.[ 1 ]?.indexOf( '.' );

export {

  validateEmail

}